import { Box, Grid, TextField, Typography, MenuItem } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { IProdutoFormData } from ".";
import SelectLoja from "../../../../../components/SelectsSimpleApiQuery/SelectLoja";

export default function Step04() {
    const { control, formState: { errors } } = useFormContext<IProdutoFormData>();

    return (
        <Box sx={{ py: 2 }}>
            <Typography variant="h6" gutterBottom>
                Dados Adicionais
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Informações complementares sobre o produto.
            </Typography>

            <Grid container spacing={2}>
                <Grid size={{xs: 12, md:6}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.pedeComprar"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Pede para comprar"
                                fullWidth
                                required
                                error={!!errors.dadosAdicionais?.pedeComprar}
                                helperText={errors.dadosAdicionais?.pedeComprar?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md:6}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.desativado"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Desativado"
                                fullWidth
                                required
                                error={!!errors.dadosAdicionais?.desativado}
                                helperText={errors.dadosAdicionais?.desativado?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md:6}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.produtoFormula"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Produto Fórmula"
                                fullWidth
                                required
                                error={!!errors.dadosAdicionais?.produtoFormula}
                                helperText={errors.dadosAdicionais?.produtoFormula?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md:6}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.ressupre"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                select
                                label="Ressupre"
                                fullWidth
                                required
                                error={!!errors.dadosAdicionais?.ressupre}
                                helperText={errors.dadosAdicionais?.ressupre?.message}
                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md:6}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.codigoAnterior"
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Código Anterior"
                                type="number"
                                fullWidth
                                slotProps={{ htmlInput: { min: "0", maxLength: 9 } }}
                                error={!!errors.dadosAdicionais?.codigoAnterior}
                                helperText={errors.dadosAdicionais?.codigoAnterior?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md:6}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.tipoItem"
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Tipo Item"
                                type="number"
                                fullWidth
                                slotProps={{ htmlInput: { min: "0", maxLength: 2 } }}
                                required
                                error={!!errors.dadosAdicionais?.tipoItem}
                                helperText={errors.dadosAdicionais?.tipoItem?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md:6}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.familia"
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Família"
                                type="number"
                                fullWidth
                                slotProps={{ htmlInput: { min: "0", maxLength: 3 } }}
                                error={!!errors.dadosAdicionais?.familia}
                                helperText={errors.dadosAdicionais?.familia?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md:6}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.tipoProduto"
                        render={({ field }) => (
                            <TextField
                                {...field}
                                label="Tipo Produto"
                                type="number"
                                fullWidth
                                slotProps={{ htmlInput: { min: "0", maxLength: 3 } }}
                                error={!!errors.dadosAdicionais?.tipoProduto}
                                helperText={errors.dadosAdicionais?.tipoProduto?.message}
                            />
                        )}
                    />
                </Grid>

                <Grid size={{xs: 12, md: 12}}>
                    <Controller
                        control={control}
                        name="dadosAdicionais.lojaCentroDistribuicao"
                        render={({ field }) => (
                            <SelectLoja
                                label="Loja Centro Distribuição"
                                possuiBtnLimpar
                                value={field.value}
                                onChange={field.onChange}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}